<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js' 
	import { landinit } from "../../../../../../api/Draftgeneration.js"
	import {
		pcaTextArr
	} from "element-china-area-data";
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				list:getdata().list,
				mxsearch:null,
				isnull:'',
				pcaTextArr
			};
		},
		props: {
			toseeUpdate: {
				type: Boolean,
				default: false
			},
		// 	showpz: { 
		// 		type: Boolean,
		// 		default: false
		// 	},
			tableData: {
				type: Array,
				default: [],
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode:{
				type:String,
				default:""
			},
			type: {
				type: String,
				default: ""
			},
		},
		created() {
			this.int()
			this.$nextTick(()=>{
			})
		},
		
		methods: {
			int(){
				landinit().then(res=>{
					this.mxsearch = res.data.data
					Object.keys(this.mxsearch).map(key=>{
						let arr = Object.keys(this.mxsearch[key]).map(keyout=>{
							return{
								value:this.mxsearch[key][keyout],
								label:keyout
							}
						})
						this.mxsearch[key] = arr
					})
				})
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			forpz() {
				if (this.showpz) {
					this.$emit("forpz", "")
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {},
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../valueAddedTax/index.less');
</style>
